import React, { useEffect, useState } from "react";
import { useParams } from "react-router";
import { Link } from "react-router-dom";

import useAppContext from "../../../hooks/useAppContext";

import { CaretLeft } from "@mbo/icons";

import { StyledButton, StyledWrapper } from "./opportunityLayout.style";
import constants from "./constants";

const OpportunityLayout = () => {
  const { axios } = useAppContext();
  const { id } = useParams();
  const [data, setData] = useState(null);
  const [supervisor, setSupervisor] = useState(null);

  useEffect(() => {
    axios
      .get("/admin/sales/opportunity/" + id)
      .then((res) => {
        setData(res.data.data);
        setSupervisor(res.data.data.supervisor?.fullName);
      })
      .catch((err) => {
        console.error(err);
      });
  }, []);

  const handleClick = (e) => {
    e.preventDefault();
    axios
      .post("/admin/sales/claim", {
        id: id,
      })
      .then((res) => {
        setSupervisor(res.data.data.supervisor);
      })
      .catch((err) => {
        console.error(err);
      });
  };

  return (
    <StyledWrapper>
      <div className="page-back-link">
        <Link to="/sales/opportunities">
          <CaretLeft />
          <span>Go back</span>
        </Link>
      </div>
      <div className="page-heading">
        <h1>Challenge Request Details</h1>
        <div className="page-controls">
          <div>
            <span className="label">Current Supervisor: </span>
            <span className="value">{supervisor || "None"}</span>
          </div>
          <StyledButton type="button" onClick={handleClick}>
            Assign to me
          </StyledButton>
        </div>
      </div>
      <div className="page-content">
        {constants.map((section, sectionIndex) => (
          <div className="page-section" key={sectionIndex}>
            <div className="section-heading">{section.heading}</div>
            {section.content.map((content, contentIndex) => (
              <div className="section-content" key={contentIndex}>
                <div className="section-label">{content.label}</div>
                <div className="section-value">
                  {(["firstName", "lastName"].includes(content.value) &&
                    ((data?.challenger && data.challenger[content.value]) ||
                      (data?.payload && data.payload[content.value]))) ||
                    (["email"].includes(content.value) && (
                      <strong>{data && data[content.value]}</strong>
                    )) ||
                    (data?.payload && data.payload[content.value])}
                </div>
              </div>
            ))}
          </div>
        ))}
      </div>
    </StyledWrapper>
  );
};

export default OpportunityLayout;
